import { useRouter } from 'next/router'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'

import { useGrass } from 'services/grass'
import { getDetailsGrass, getGrass } from 'services/grass/action'

import Layout from 'components/Layout/Default'
import Container from 'components/Container'
import Comments from 'components/Comments'

import PostFlex from 'components/Post/Flex'
import PostLeft from 'components/Post/Left'
import PostCover from 'components/Post/Cover'
import PostAbout from 'components/Post/About'
import PostTable from 'components/Post/Table'
import PostFeatures from 'components/Post/Features'
import PostAuthor from 'components/Post/Author'
// import PostSocials from "components/Post/Socials";

import * as S from './styles.slug'
import { countComments, transformHttpToHttps } from 'utils'
import { useEffect, useRef, useState } from 'react'
import LightGalery from 'components/LightGalery'

const Slug = ({ data }) => {
  const [isSmallScreen, setIsSmallScreen] = useState(false)

  const { push } = useRouter()
  const { data: relatedGrass } = useGrass()
  const bodyRef = useRef(null)

  useEffect(() => {
    const jsSnippetWithoutReplace = data?.acf?.snippets
    const jsSnippet = jsSnippetWithoutReplace.replace(
      '_reviewCount_',
      countComments(data?.acf?.comments)
    )

    const scriptTag = document.querySelector(
      'script[type="application/ld+json"]'
    )
    scriptTag?.remove()

    if (!scriptTag && jsSnippet) {
      document
        ?.querySelector('body')
        ?.insertAdjacentHTML('beforeend', jsSnippet)
    }
    return () => {
      const script = document.querySelector(
        'script[type="application/ld+json"]'
      )
      script?.remove()
    }
  }, [data?.acf])

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 445)
    }

    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <Layout
      category={data?.title?.rendered}
      title={`${data?.acf?.seo.title}`}
      subtitle={data?.acf?.scientific_name}
      description={`${data?.acf?.seo.description}`}
      h2={`${data?.acf?.seo.description}`}
      keywords={`${data?.acf?.seo.keywords}`}
      links={`${data?.slug}`}
      cover={`${data?.cover}`}
      categorySize="1.6rem"
    >
      <section>
        <Container>
          <PostFlex>
            <PostLeft>
              <PostCover
                cover={
                  isSmallScreen
                    ? transformHttpToHttps(data?.x_featured_media_original)
                    : transformHttpToHttps(data?.acf?.capa_gramas_img)
                }
                description={
                  isSmallScreen
                    ? data?.excerpt?.rendered
                    : data?.acf?.capa_gramas_alt
                }
                title={
                  isSmallScreen
                    ? data?.title?.rendered?.toLowerCase()
                    : data?.acf?.capa_gramas_title
                }
              />
              <PostAbout
                author={data?.x_author}
                date={data?.date}
                qtd_comments={
                  data?.acf?.comments ? countComments(data?.acf?.comments) : '0'
                }
              />
              <S.Content
                ref={bodyRef}
                dangerouslySetInnerHTML={{ __html: data?.content?.rendered }}
              />
              <PostTable
                title="Caracteristcas"
                itens={data?.acf?.particulars}
              />
              <PostFeatures
                title="Principais indicações"
                status="positive"
                itens={data?.acf?.indications}
              />
              <PostFeatures
                title="Vantagens"
                status="positive"
                itens={data?.acf?.benefits}
              />
              <PostFeatures
                title="Desvantagens"
                status="negative"
                itens={data?.acf?.disadvantages}
              />
              <PostAuthor
                name={data?.x_author}
                description={data?.author.author_description}
                thumbnail={data?.author.author_avatar}
              />
              {/* <PostSocials
                url={`https://centraldagrama.com/${data?.slug}`}
                keywords={data?.tags}
              /> */}
              <Comments comments={data?.acf?.comments} postId={data?.id} />
            </PostLeft>
            <S.Right>
              <h4>Outras Gramas</h4>

              {relatedGrass?.map((item) => (
                <S.Others
                  key={`others-item-${item.id}`}
                  onClick={() => push(`/${item.slug}`)}
                >
                  <S.OthersFigure>
                    <S.OthersFigureImage
                      src={transformHttpToHttps(item.x_featured_media_original)}
                      title={item?.acf?.title_img_othergrass}
                      alt={item?.acf?.alt_img_othergrass}
                    />
                  </S.OthersFigure>
                  <S.OthersRight>
                    <S.OthersTitle title={item?.acf?.title_text_othergrass}>
                      {item?.title?.rendered}
                    </S.OthersTitle>
                    <S.OthersBottom>
                      <S.OthersText>{item.x_author}</S.OthersText>
                      <S.OthersText>
                        {format(new Date(item.date), 'EEEE, d MMMM, Y ', {
                          locale: ptBR,
                        })}
                      </S.OthersText>
                    </S.OthersBottom>
                  </S.OthersRight>
                </S.Others>
              ))}
            </S.Right>
          </PostFlex>
        </Container>
      </section>

      <LightGalery ref={bodyRef} body={data?.content?.rendered} />
    </Layout>
  )
}

export default Slug

export async function getStaticProps(context) {
  const data = await getDetailsGrass(context.params?.id)

  return {
    props: {
      data,
    },
    revalidate: 10,
  }
}

export async function getStaticPaths() {
  const data = await getGrass()

  const paths = data.map((item) => ({
    params: {
      id: String(item.slug),
    },
  }))

  return { paths, fallback: 'blocking' }
}
